"use strict";

$(document).ready(function () {
  var feedbackform = document.getElementById('feedbackform');
  if (feedbackform) {
    var feedbackyes = document.getElementById('feedbackyes');
    var feedbackno = document.getElementById('feedbackno');
    var feedbacknosubmit = document.getElementById('feedbacknosubmit');
    var feedbackbuttons = document.getElementById('feedbackbuttons');
    var thankyoumessage = document.getElementById('thankyou');
    var feedbackfields = document.getElementById('feedbackfields');
    var feedbackemail = document.getElementById('feedbackemail');
    var feedbackmessage = document.getElementById('feedbackmessage');
    var thumbsUpContainer = document.querySelector('.thumbs-up');
    var feedbackContent = document.querySelector('.content');

    //assign logic to yes
    feedbackyes.addEventListener('click', function (e) {
      e.preventDefault();
      thumbsUpContainer.style.display = 'none';
      feedbackbuttons.style.display = 'none';
      thankyoumessage.style.display = 'block';
      feedbackContent.classList.add('center');

      //make ajax call to backend
      var apiUrl = "/api/sitecore/Feedback/sendFeedback?feedback=yes&url=" + window.location.href;
      makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
        if (isNetworkSuccess) {
          //console.log("we did it positive");        
        }
      });
    });

    //assign logic to no
    feedbackno.addEventListener('click', function (e) {
      e.preventDefault();
      thumbsUpContainer.style.display = 'none';
      feedbackbuttons.style.display = 'none';
      thankyoumessage.style.display = 'block';
      feedbackfields.style.display = 'block';
      feedbackContent.classList.add('center');
    });
    feedbacknosubmit.addEventListener('click', function (e) {
      e.preventDefault();
      //validate fields are filled
      if (feedbackemail.value == "" || feedbackmessage.value == "") {
        if (feedbackemail.value == "") {
          var feedbackemailerror = document.getElementById('feedbackemail-error');
          feedbackemailerror.style.display = "block";
        } else {
          var feedbackemailerror = document.getElementById('feedbackemail-error');
          feedbackemailerror.style.display = "none";
        }
        if (feedbackmessage.value == "") {
          var feedbackmessageerror = document.getElementById('feedbackmessage-error');
          feedbackmessageerror.style.display = "block";
        } else {
          var feedbackmessageerror = document.getElementById('feedbackmessage-error');
          feedbackmessageerror.style.display = "none";
        }
      } else {
        //check captcha
        if (grecaptcha && grecaptcha.getResponse().length > 0) {
          //make ajax call to backend
          var apiUrl = "/api/sitecore/Feedback/sendFeedback?feedback=no&url=" + window.location.href + "&email=" + feedbackemail.value + "&feedbackmessage=" + feedbackmessage.value + "&captcha=" + grecaptcha.getResponse();
          makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
            if (isNetworkSuccess) {
              thumbsUpContainer.style.display = 'none';
              feedbackfields.style.display = "none";
              thankyoumessage.style.display = 'block';
            }
          });
        }
      }
    });
  }
});